import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M4 11a9 9 0 0 1 9 9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 4a16 16 0 0 1 16 16", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "5", cy: "19", r: "1", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Rss";
const Rss = memo(themed(Icon));
export {
  Rss
};
//# sourceMappingURL=rss.js.map
